module.exports = __webpack_public_path__ + "static/media/businesslunch-catering-3.60d10698.jpg";